<template>
  <div class="main">
    <navigation></navigation>
    <router-view/>
    <footerDIV></footerDIV>
  </div>
</template>

<script>
import navigation from '@/components/navigation.vue'
import footerDIV from '@/components/footer.vue'

export default {
  name: 'Main',
  components: {
    navigation, footerDIV
  }
}
</script>
